
import { getIcon } from '~/utils/get-icon.js'
import RichTextSection from '~/components/public/rich-text-section.vue'

export default {
  components: {
    RichTextSection,
  },
  props: {
    // Required
    title: {
      type: String,
      required: true,
    },
    text: {
      type: Object,
      required: true,
    },

    // Optional
    subtitle: {
      type: String,
      default: '',
    },

    cta: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    hasActions() {
      return this.cta.length > 0
    },
  },

  methods: {
    getButtonIcon(key) {
      return getIcon(key)
    },
  },
}
